import { registerBlockType } from '@wordpress/blocks';
import { formatListNumbered as icon } from '@wordpress/icons';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: icon,
  },
});
